import { FunctionComponent } from 'react'
import { Button } from './Button/Button.tsx'
import { Cta } from './Cta/Cta.tsx'
import { BookOpen, Camera, CaseSensitive, HelpCircle, Hourglass, ShoppingCart } from 'lucide-react'
import { useIntlayer } from 'react-intlayer'
import { Spinner } from '../Spinner/Spinner'

type ToolbarProps = {
  onAddText: () => void
  onChooseImage: () => void
  onUploadPhoto: () => void
  onAddToCart: () => void
  onShowHelp?: () => void
  isUploading: boolean
  isSaving: boolean
  isAddingToCart: boolean
  isEditMode?: boolean
  showUploadPhoto?: boolean
}

export const Toolbar: FunctionComponent<ToolbarProps> = ({
  onAddText,
  onChooseImage,
  onUploadPhoto,
  onAddToCart,
  onShowHelp,
  isUploading,
  isSaving,
  isAddingToCart,
  isEditMode = false,
  showUploadPhoto = true,
}) => {
  const { addText, addImage, uploadPhoto, uploading, addToCart, saving } = useIntlayer('toolbar')

  return (
    <div className="absolute top-4 right-4 flex items-center gap-2 z-20" data-gtm="toolbar">
      <Button
        onClick={onAddText}
        icon={<CaseSensitive />}
        label={addText}
        disabled={isAddingToCart}
        data-gtm="add-text-button"
      />
      <Button
        onClick={onChooseImage}
        icon={<BookOpen />}
        label={addImage}
        disabled={isAddingToCart}
        data-gtm="choose-image-button"
      />
      {showUploadPhoto && (
        <Button
          onClick={onUploadPhoto}
          icon={isUploading ? <Hourglass /> : <Camera />}
          label={isUploading ? uploading : uploadPhoto}
          disabled={isAddingToCart || isUploading}
          data-gtm="upload-photo-button"
        />
      )}
      {!isEditMode && (
        <Cta
          onClick={onAddToCart}
          icon={
            isAddingToCart ? (
              <Spinner size="sm" color="white" />
            ) : isSaving ? (
              <Hourglass color={'white'} />
            ) : (
              <ShoppingCart color={'white'} />
            )
          }
          label={isAddingToCart ? addToCart : isSaving ? saving : addToCart}
          disabled={isAddingToCart || isSaving}
          data-gtm="add-to-cart-button"
        />
      )}
      {onShowHelp && (
        <button
          onClick={onShowHelp}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
          title="Help"
          data-gtm="help-button"
        >
          <HelpCircle className="h-6 w-6 text-gray-600" />
        </button>
      )}
    </div>
  )
}
